import {
  LoginIframePage,
  LoginPage,
  LoginPageExports,
  withAuthPageLogging,
} from '@jusbrasil-web/auth/core'
import { useRouter } from 'next/router'
import type { ComponentProps } from 'react'

const { getServerSideProps: getServerSidePropsRaw } = LoginPageExports
const getServerSideProps = withAuthPageLogging(__filename, getServerSidePropsRaw)
export { getServerSideProps }

type LoginPageProps = ComponentProps<typeof LoginPage>

function LoginRoute(props: LoginPageProps) {
  const { query } = useRouter()
  if (query.usage === 'iframe') return <LoginIframePage {...props} />
  return <LoginPage {...props} />
}

export default LoginRoute
